import styled from 'styled-components'

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 136px;
`

export const FixButtonWrapper = styled.div`
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  z-index: 3;
  padding: 0 16px 0;
`
